import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AutoSaveContextType } from '../types/tender.types';

const AutoSaveContext = createContext<AutoSaveContextType | undefined>(undefined);

export const AutoSaveProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [lastSaved, setLastSaved] = useState<Date | null>(null);
  const [saveStatus, setSaveStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle');

  // ============================================================
  // EXCEL IMPORT AUTO-SAVE DISABLED - Commented out for now
  // ============================================================
  // // Listen for Excel import complete event to trigger immediate save
  // useEffect(() => {
  //   const handleImportComplete = async () => {
  //     console.log('Excel import complete - triggering immediate save');
  //     if (isSaving) return; // Skip if already saving

  //     try {
  //       setIsSaving(true);
  //       setSaveStatus('saving');

  //       // Wait for React state updates to complete and propagate
  //       // Increased delay from 100ms to 1000ms to ensure all state updates finish
  //       console.log('Waiting for state to update before saving...');
  //       await new Promise(resolve => setTimeout(resolve, 1000));

  //       console.log('Saving tender to storage...');
  //       await saveTenderRef.current();
  //       setLastSaved(new Date());
  //       setSaveStatus('saved');

  //       console.log('Save completed successfully!');
  //       setTimeout(() => setSaveStatus('idle'), 2000);
  //     } catch (error) {
  //       setSaveStatus('error');
  //       console.error('Immediate save after import failed:', error);
  //     } finally {
  //       setIsSaving(false);
  //     }
  //   };

  //   window.addEventListener('excel-import-complete', handleImportComplete as EventListener);
  //   return () => window.removeEventListener('excel-import-complete', handleImportComplete as EventListener);
  // }, [isSaving]);

  // ============================================================
  // AUTO-SAVE DISABLED - Commented out for now
  // ============================================================
  // useEffect(() => {
  //   if (!state.isDirty) return;
  //   if (isSaving) return; // Prevent multiple saves

  //   const timeoutId = setTimeout(async () => {
  //     try {
  //       setIsSaving(true);
  //       setSaveStatus('saving');

  //       await new Promise(resolve => setTimeout(resolve, 500));

  //       await saveTenderRef.current();
  //       setLastSaved(new Date());
  //       setSaveStatus('saved');

  //       setTimeout(() => setSaveStatus('idle'), 2000);
  //     } catch (error) {
  //       setSaveStatus('error');
  //       console.error('Auto-save failed:', error);
  //     } finally {
  //       setIsSaving(false);
  //     }
  //   }, 5000);

  //   return () => clearTimeout(timeoutId);
  // }, [state.isDirty, state.lastModified, isSaving]);

  const value: AutoSaveContextType = {
    isSaving,
    lastSaved,
    saveStatus,
  };

  return <AutoSaveContext.Provider value={value}>{children}</AutoSaveContext.Provider>;
};

export const useAutoSave = (): AutoSaveContextType => {
  const context = useContext(AutoSaveContext);
  if (context === undefined) {
    throw new Error('useAutoSave must be used within an AutoSaveProvider');
  }
  return context;
};